/**
 * Shared scroll/height class for every Shadow AI DataTable (KIR-3903).
 *
 * Each Shadow AI table used to hard-code `h-[700px]` on its outer flex shell, so
 * even an empty table reserved 700px and buried the tables below it with no cue
 * to scroll. Capping the height and letting the body scroll internally keeps a
 * short/empty table compact while a full table scrolls within the cap.
 */
export const SHADOW_AI_TABLE_SCROLL_CLASS = 'overflow-auto max-h-[600px]';

/**
 * Clarifying copy for the Shadow AI Browser AI Tools and Running Now surfaces
 * (KIR-3893). Browser tools are detected from browser history — a record of a
 * past visit — so they can never report a live "Running Now" status. The
 * "Just now" relative label can look live, so these strings make the
 * expected behavior explicit in the UI. Centralized here so the Organization
 * and Personal Dashboard surfaces stay in sync.
 */
export const BROWSER_TOOLS_LAST_SEEN_TOOLTIP =
  'Browser tools are found from browser history. Last Seen is the time of the last recorded visit. A live status (Running Now) is not tracked for browser tools.';

export const BROWSER_TOOLS_HELPER_LINE =
  'Detected from browser history. These are past visits, not live sessions.';

export const RUNNING_NOW_NOTE =
  'Shows installed desktop tools that report a live status. Browser tools are detected from history and are not shown here.';

/**
 * KIR-4997: an approval keys on the tool, not the process, so approving one
 * Running Now row approves every running instance of that tool (and
 * unapproving one unapproves them all). Shown on the row's Approve / Unapprove
 * buttons on the Organization and Personal Dashboard Running Now tabs.
 */
export const RUNNING_NOW_APPROVAL_TOOLTIPS = {
  approve: 'Running Tool approval will approve all of its running instances',
  unapprove:
    'Unapproving a running tool will unapprove all of its running instances',
} as const;
